import React from "react";
import Marquee from "../Marquee";
import PetTagReviewCard from "../Card";
import SectionHeading from "../../SectionHeading";
import { petTagReviewData } from "@/utils/data/petReviewData";
import { iconMap } from "../icons";

function PetReviewSection() {
  return (
    <section className="py-[6.25rem]">
      <SectionHeading title="User Reviews" className="mb-[3.75rem]" />
      <section className="relative flex justify-center h-[51.875rem] overflow-hidden md:space-x-[2rem]  bg-white bg-gradient-to-r from-white via-[#e0dfe5] to-white">
        <div className="bg-gradient-to-b from-white to-transparent w-full absolute top-0 h-[11.25rem] z-20"></div>

        <div className="w-[90%] md:w-auto">
          <Marquee direction="up" reverse={false} pauseOnHover={true}>
            {petTagReviewData.one.map((review, index) => (
              <PetTagReviewCard
                key={index}
                name={review.name}
                location={review.location}
                reviewContent={review.content}
                orgLogo={iconMap[review.org]}
                reviewLogo={iconMap[review.reviewIconType]}
              />
            ))}
          </Marquee>
        </div>

        <div className="hidden md:block">
          <Marquee direction="up" reverse={true} pauseOnHover={true}>
            {petTagReviewData.two.map((review, index) => (
              <PetTagReviewCard
                key={index}
                name={review.name}
                location={review.location}
                reviewContent={review.content}
                orgLogo={iconMap[review.org]}
                reviewLogo={iconMap[review.reviewIconType]}
              />
            ))}
          </Marquee>
        </div>

        <div className="hidden md:block">
          <Marquee direction="up" reverse={false} pauseOnHover={true}>
            {petTagReviewData.three.map((review, index) => (
              <PetTagReviewCard
                key={index}
                name={review.name}
                location={review.location}
                reviewContent={review.content}
                orgLogo={iconMap[review.org]}
                reviewLogo={iconMap[review.reviewIconType]}
              />
            ))}
          </Marquee>
        </div>

        <div className="hidden md:block">
          <Marquee direction="up" reverse={true} pauseOnHover={true}>
            {petTagReviewData.four.map((review, index) => (
              <PetTagReviewCard
                key={index}
                name={review.name}
                location={review.location}
                reviewContent={review.content}
                orgLogo={iconMap[review.org]}
                reviewLogo={iconMap[review.reviewIconType]}
              />
            ))}
          </Marquee>
        </div>
        <div className="bg-gradient-to-b from-transparent to-white w-full absolute bottom-0 h-[11.25rem] z-20"></div>
      </section>
    </section>
  );
}

export default PetReviewSection;
